import * as Sentry from "@sentry/react";
import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset, SidebarTrigger, Toaster, ThemeToggle } from "@athena/ui";
import { AppSidebar } from "@/components/AppSidebar";
import { ErrorFallback } from "@/components/ErrorFallback";

export function RootLayout() {
    return (
        <SidebarProvider>
            <AppSidebar />
            <SidebarInset>
                <header className="bg-background border-border sticky top-0 z-40 flex h-12 items-center justify-between gap-2 border-b px-4">
                    <SidebarTrigger className="z-50 h-4 w-4" />
                    <ThemeToggle />
                </header>
                <main className="flex flex-col">
                    <Sentry.ErrorBoundary
                        fallback={({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />}
                    >
                        <Outlet />
                        <Toaster />
                    </Sentry.ErrorBoundary>
                </main>
            </SidebarInset>
        </SidebarProvider>
    );
}
